<script lang="ts">
    import Icon from "@components/material/Icon.svelte"
    import { Effect } from "effect"
    import { fade } from "svelte/transition"
    // import OffscreenQuote from "./OffscreenQuote.svelte"
    import FullCenter from "@components/layout/FullCenter.svelte"
    import SharePicture from "@components/share-picture/SharePicture.svelte"
    import { Blobbify } from "@utils/helpers/blobbable"
    import { DownloadBlob } from "@utils/share/download"
    import { ShareBlob } from "@utils/share/share"
    import Bitmap from "./Bitmap.svelte"

    /**
     * Base64 image
     */
    // export let image: ReturnType<typeof getQuoteImage>
    export let bitmap: ImageBitmap
    export let quote: string
    export let url: string
    export let tooBig: boolean
    export let allTooMuchText: boolean = false

    let canvas: HTMLCanvasElement | undefined = undefined
    const getBlob = Effect.fn("getBlob")((canvas: HTMLCanvasElement) =>
        Blobbify(canvas, "image/jpeg", 0.85),
    )

    const downloadQuote = Effect.fn("downloadQuote")(function* (canvas: HTMLCanvasElement) {
        const blob = yield* getBlob(canvas)
        yield* DownloadBlob(blob, "image")
    })

    const shareQuote = Effect.fn("shareQuote")(function* (canvas: HTMLCanvasElement) {
        const blob = yield* getBlob(canvas)
        yield* ShareBlob(
            blob,
            {
                // url,
                // text: stripHtml(quote),
                // title: "A Course in Miracles",
            },
            "ACIM",
        )
    })
</script>

<div class="w-full aspect-square relative">
    {#if canvas}
        <SharePicture
            enabled={!!canvas && !tooBig}
            download={downloadQuote(canvas)}
            share={shareQuote(canvas)}
        />
    {/if}
    <div class="w-full aspect-square rounded-xl overflow-hidden bg-gray-400 bg-opacity-20 relative">
        <div class="w-full h-full flex relative items-center justify-center" transition:fade>
            <Bitmap
                bind:canvas
                {bitmap}
                class={`w-full h-full absolute object-contain flex ${tooBig ? "opacity-20" : ""}`}
            />
            {#if tooBig}
                <FullCenter class="absolute">
                    <!-- <Icon icon="circle-warning" class="w-8" /> -->
                    <div>
                        {#if allTooMuchText}
                            <span class="text-xl"> No images fit the text. </span> <br />
                            <span class="text-lg"> Try reducing the text. </span>
                        {:else}
                            <span class="text-xl"> Too much text for this image. </span> <br />
                            <span class="text-lg"> Try reducing the text. </span>
                        {/if}
                    </div>
                </FullCenter>
            {/if}
        </div>
    </div>
</div>
